import Multimedia from "@sharedComponents/multimedia";
import Link from "next/link";
import { useSelector } from "react-redux";

import { getIsLockerShop } from "@selectors/store";

import emptyBag from "@images/svg/empty-bag.svg";

import styles from "./main.module.scss";

export const EmptyBag = ({ menuPath, className }) => {
  const isLockerShop = useSelector(getIsLockerShop);
  return (
    <div className={`${styles.emptyBagContainer} empty-bag-container ${className}`}>
      <div className={styles.innerContainer}>
        <Multimedia src={emptyBag} type="image" width={119} height={104} alt="Your bag is empty" />
        <h3 className={styles.bagHeading}>Your bag is empty</h3>
        <div>
          Fill up your bag with our endless
          <span className={styles.spanLgBlock}>
            {" "}
            options.{" "}
            <div className={styles.blockInlineBlock}>
              <Link href={menuPath} className={styles.linkShopMenu} prefetch={false}>
                {isLockerShop ? "Purchase Swag" : "Shop Menu"}
              </Link>
            </div>
          </span>
        </div>
      </div>
    </div>
  );
};
